module.exports = __webpack_public_path__ + "img/arrow-up.3031172c.svg";